import React from 'react'

const Loading = () => {
  return <div className="atp-loading"></div>
}

export default Loading
